import { styled } from '@mui/material/styles';
import { applicationSidePaddingPx, stickyFooterHeightCssVar } from 'core/theme/constants';

export const ScrollableBodyStyled = styled('div')<{ gutterBottom?: boolean }>`
  position: relative;
  flex-grow: 1;
  width: calc(100% + ${applicationSidePaddingPx * 2}px);
  min-height: 0;
  margin-top: 24px;
  margin-bottom: ${({ gutterBottom }) => (gutterBottom ? 'auto' : 0)};
  margin-inline-start: -${applicationSidePaddingPx}px;
  padding: 24px ${applicationSidePaddingPx}px
    calc(${applicationSidePaddingPx}px + var(${stickyFooterHeightCssVar}, 0px));
  border-radius: 16px 16px 0 0;
  overflow-y: scroll;
  background-color: ${({ theme }) => theme.palette.contentBlockBackground.secondary};
`;
